module.exports = [
    "data.service", function(dataService) {
        var bannerMessages = {
            BannerMessage : {},
        };
        function getBannerMessages() {
            return dataService.get("bannerMessages");
        }
        return {
            getBannerMessages: getBannerMessages,
            bannerMessages : bannerMessages
        }
    }
];  




